<template lang="pug">
.camp-list
  .page-header
    h1 所有營地列表

  .content-wrapper
    el-table(
      v-loading="loading"
      :data="camps"
      style="width: 100%"
      @row-click="handleRowClick"
    )
      el-table-column(
        prop="name"
        label="營地名稱"
        min-width="200"
      )
        template(#default="scope")
          span.camp-name {{ scope.row.name }}

      el-table-column(
        prop="site"
        label="來源"
        width="180"
      )
        template(#default="scope")
          span {{ getSiteDisplay(scope.row.site) }}

      el-table-column(
        prop="area"
        label="地區"
        width="120"
      )

</template>

<script>
import { API_ENDPOINTS } from '../config/api'
import { getToken } from '../utils/token'

export default {
  name: 'CampList',
  data() {
    return {
      camps: [],
      loading: false
    }
  },
  created() {
    document.title = '台灣露營地搜尋'
    this.fetchCampList()
  },
  methods: {
    async fetchCampList() {
      this.loading = true
      try {
        const token = getToken()
        const response = await fetch(`${API_ENDPOINTS.CAMP_BASE}/list`, {
          headers: {
            'X-Validation': token
          }
        })
        const data = await response.json()
        this.camps = data
      } catch (error) {
        console.error('獲取營地列表失敗:', error)
        this.$message.error('獲取營地列表失敗')
      } finally {
        this.loading = false
      }
    },
    getSiteDisplay(site) {
      const siteMap = {
        icamping: '愛露營',
        easycamp: '露營樂',
        twcamping: '台灣露營地訂位中心'
      }
      return siteMap[site] || site
    },
    handleRowClick(row) {
      this.$router.push({
        name: 'CampDetail',
        params: {
          site: row.site,
          id: row.id
        }
      })
    }
  }
}
</script>

<style scoped>
.camp-list {
  padding: 20px;
  max-width: 1200px;
  margin: 0 auto;
}

.page-header {
  text-align: center;
  margin-bottom: 40px;
}

.page-header h1 {
  font-size: 32px;
  color: #303133;
}

.content-wrapper {
  background: #fff;
  border-radius: 8px;
  padding: 24px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.camp-name {
  color: #409EFF;
  cursor: pointer;
}

.camp-name:hover {
  text-decoration: underline;
}

@media (max-width: 768px) {
  .camp-list {
    padding: 16px;
  }

  .page-header h1 {
    font-size: 24px;
  }

  .content-wrapper {
    padding: 16px;
  }
}
</style> 